import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import * as actions from '../../../../actions/providers.actions';
import * as home from '../../../../actions/process.home.actions';
import * as inventory from '../../../../actions/process.inventory.actions';

import Error from '../../../dialogs/Error';
import Menu from '../Menu';
import List from './List';
import { AddIcon } from '../../../../images/icons/WrapSvg';

class Providers extends React.Component {
    state = {
        hide: false,
    };

    constructor(props) {
        super(props);
        props.loadProviders();
        this.props.setSearch(true);
    }

    componentDidMount() {
        this.props.setInventoryWindow("providers");
    }

    componentWillUnmount() {
        this.props.setSearch(false);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.providers_has_error) {
            props.loadProviders();
            return null;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleClick = (event) => {
        this.props.history.push('/manage/new_providers');
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '62') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full'}>
                        <div className={'flex_full overflow_y_scroll center height100 bg_ice_blue showbar'}>
                            <List />
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleClick}
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Providers.propTypes = {
    providers_is_loading: PropTypes.bool.isRequired,
    providers_has_errored: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        providers_is_loading: state.providers_is_loading,
        providers_has_errored: state.providers_has_errored,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home, inventory), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Providers));



// WEBPACK FOOTER //
// ./src/components/complex/manage/providers/Index.js